export class Estrairep {
    mese:any;
    anno:any;
    idmese:any;
}
